import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Bubble } from 'tea-component';
import { useIntl } from 'umi';
import TipContext from '@home/components/TipContextComponents/TipContext';
import { useFilterOptionList } from '@/pages/intelligence/hooks/useFilterOptionList';
import SelectorMultiple from './SelectorMultiple';

export const segmentTooltip = (text: string, tooltip: string) => {
  return (
    <Bubble
      dark
      content={
        <>
          <span>{tooltip}</span>
        </>
      }
    >
      <div className={`segment-bubble-text`}>{text}</div>
    </Bubble>
  );
};

interface IMultipleSelectContext {
  tips?: string;
  AWidth?: number;
  value?: Array<string>;
  onConfirm?: Function;
  segmentType?: string;
  locale?: string;
  btnNameKey?: string;
  marginStyle?: string;
  optionsOutList?: any;
  filterLoading?: any;
  isNeedHeaderTitle?: boolean;
}

export default function MultipleSelectContext(props: IMultipleSelectContext) {
  const {
    AWidth,
    tips,
    value: defaultValue,
    onConfirm,
    segmentType = 'DIGITAL_SEGEMENT',
    optionsOutList,
    isNeedHeaderTitle = true,
    btnNameKey,
    marginStyle = '0 10px 10px 0',
  } = props;

  const { formatMessage } = useIntl();
  const [segmentVal, setSegmentVal] = useState(defaultValue);

  const hasUpdateValueRef = useRef(false);

  // 外层传值变化时，更新值
  useEffect(() => {
    setSegmentVal(defaultValue);
  }, [defaultValue]);

  const { multipleSegmentFilterOptions } = useFilterOptionList({
    formatMessage,
    segmentTooltip,
    optionsOutList,
  });

  const btnNameCur = useMemo(() => {
    if (btnNameKey) {
      return btnNameKey;
    }
    switch (segmentType) {
      case 'ENGAGELEVEL_SEGEMENT':
        return 'dbi_filter_segment_engagement';
      case 'DIGITAL_SEGEMENT':
      default:
        return 'dbi_filter_segment';
    }
  }, [segmentType]);

  const widthCur = useMemo(() => {
    switch (segmentType) {
      case 'ENGAGELEVEL_SEGEMENT':
        return 220;
      case 'DIGITAL_SEGEMENT':
      default:
        return 198;
    }
  }, [segmentType]);

  const optionsCur = useMemo(() => {
    if (Array.isArray(optionsOutList) && optionsOutList?.length > 0) {
      return optionsOutList;
    }
    return multipleSegmentFilterOptions;
  }, [multipleSegmentFilterOptions, optionsOutList]);

  return (
    <>
      <SelectorMultiple
        value={segmentVal}
        options={optionsCur}
        matchButtonWidth
        label={formatMessage({ id: btnNameCur })}
        allDescribe={formatMessage({ id: 'dbi_segment_all' })}
        iconTip={
          tips && (
            <div style={{ marginRight: 6, lineHeight: 0 }}>
              <TipContext Performance="left" AWidth={AWidth} tipText={tips} />
            </div>
          )
        }
        style={{ width: widthCur, margin: marginStyle }}
        onChange={(value) => {
          hasUpdateValueRef.current = true;
          setSegmentVal(value);
          // if (onConfirm instanceof Function) {
          //   onConfirm(value);
          // }
        }}
        onClose={() => {
          if (!hasUpdateValueRef.current) return;
          if (onConfirm instanceof Function) {
            onConfirm(segmentVal);
          }
          hasUpdateValueRef.current = false;
        }}
        isNeedHeaderTitle={isNeedHeaderTitle}
      />
    </>
  );
}
